export default "__VITE_PUBLIC_ASSET__a3a36b5d__"